import {
    extractPartialConnectivityParams,
    getPartialConnectivityFilterKeys,
} from "../Filters/FilterTimeRangeExtractor";

/**
 * Filters for a select-all action on the All Vehicles list, in the form the list
 * request sends them, so the backend re-run of the list matches the rows on screen.
 *
 * The backend copies each key onto the list arguments. Most table filters are sent
 * as-is, like the list does. The "Batteries Offline" filter is not: the list turns
 * its raw picks into canDataTypes (display values) and a canDataDateRange date range,
 * and the backend cannot read the raw form - it silently drops the filter, so a
 * select-all would cover every vehicle matching the other filters.
 *
 * @param {object} args
 * @param {object} args.selectedFilters  - the table's selected filters
 * @param {object} [args.searchTerm]     - { selectedDevices, selectedSearchColumn }
 * @param {object} [args.filterConfigsMap] - filter key -> filter config, as the list uses
 */
export const buildSelectAllFilters = ({ selectedFilters = {}, searchTerm, filterConfigsMap = null }) => {
    const partialConnectivityKeys = getPartialConnectivityFilterKeys(selectedFilters);
    const filters = Object.keys(selectedFilters || {}).reduce((acc, key) => {
        if (!partialConnectivityKeys.includes(key)) {
            acc[key] = selectedFilters[key];
        }
        return acc;
    }, {});

    const partialConnectivity = extractPartialConnectivityParams(selectedFilters, filterConfigsMap);
    if (partialConnectivity?.canDataTypes) {
        filters.canDataTypes = partialConnectivity.canDataTypes;
    }
    if (partialConnectivity?.canDataDateRange) {
        // The list request sends it JSON-encoded, and the backend json.loads it.
        filters.canDataDateRange = JSON.stringify(partialConnectivity.canDataDateRange);
    }

    const searchDevices = searchTerm?.selectedDevices || [];
    if (searchDevices.length > 0) {
        filters[searchTerm.selectedSearchColumn || "searchID"] = searchDevices;
    }
    return filters;
};
